import { Map, List } from 'immutable'
import _get from 'lodash/get'
import * as actions from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case actions.GET_USER_ABUSE_REPORTS:
      return state.set('processing', payload.processing)
    case actions.SET_USER_ABUSE_UNRESOLVED_PROCESSING:
      return state.set('processingUnresolved', payload.processing)
    case actions.SET_USER_ABUSE_PROCESSING:
      return state.set('processing', payload.processing)
    case actions.SET_USER_ABUSE_REPORTS:
      return state
        .set('data', _get(payload, 'data', Map()))
        .set('processing', false)
        .set('error', null)
        .set('message', null)
    case actions.SET_USER_ABUSE_REPORT: {
      const reports = state.getIn(['data', 'reports'], List()) // List??
      const { reportId } = payload
      const reportIndex = reports.findIndex((r) => r.get('id') === reportId)
      const updatedReports = reports.set(reportIndex, _get(payload, 'data', Map()))
      return state
        .setIn(['data', 'reports'], updatedReports)
        .set('processing', false)
        .set('error', null)
        .set('message', null)
    }
    case actions.SET_USER_ABUSE_ACCUSED_REPORTS: {
      return state
        .setIn(['user', 'accused', 'data'], _get(payload, 'data', Map()))
        .set('processing', false)
        .set('error', null)
        .set('message', null)
    }
    case actions.SET_USER_ABUSE_ACCUSER_REPORTS: {
      return state
        .setIn(['user', 'accuser', 'data'], _get(payload, 'data', Map()))
        .set('processing', false)
        .set('error', null)
        .set('message', null)
    }
    case actions.SET_USER_ABUSE_ACCUSED_REPORT: {
      const accused = state.getIn(['user', 'accused', 'data', 'reports'], List())
      const { reportId } = payload
      const reportIndex = accused.findIndex((r) => r.get('id') === reportId)
      const updatedAccused = accused.set(reportIndex, _get(payload, 'data', Map()))
      return state
        .setIn(['user', 'accused', 'data', 'reports'], updatedAccused)
        .set('processing', false)
        .set('error', null)
        .set('message', null)
    }
    case actions.SET_USER_ABUSE_ACCUSER_REPORT: {
      const accuser = state.getIn(['user', 'accuser', 'data', 'reports'], List())
      const { reportId } = payload
      const reportIndex = accuser.findIndex((r) => r.get('id') === reportId)
      const updatedAccuser = accuser.set(reportIndex, _get(payload, 'data', Map()))
      return state
        .setIn(['user', 'accuser', 'data', 'reports'], updatedAccuser)
        .set('processing', false)
        .set('error', null)
        .set('message', null)
    }
    case actions.SET_USER_ABUSE_REPORTS_ERROR:
      return state
        .set('data', [])
        .set('processing', false)
        .set('error', payload.error)
        .set('message', null)
    case actions.SET_USER_ABUSE_UNRESOLVED_COUNT:
      return state.set('unresolvedCount', payload.data.get('count')).set('processingUnresolved', false)
    default:
      return state
  }
}
